const DEMO = {
    BLANK_LINK: "#!",
    LOGIN: "login"
};

export default DEMO;